import { useCallback } from 'react';
import { usePropertyField } from '@vibesites/runtime/react';
import { isCanadianProperty, toCanadianSpelling } from '../utils/propertyCountry';

/** Returns a function that rewrites US spellings to Canadian ones on Canadian properties. */
export function useLocalizedSpelling(): (text: string) => string {
  const country = usePropertyField('property_address_country');
  const state = usePropertyField('property_address_state');
  const isCanadian = isCanadianProperty(country, state);
  return useCallback((text: string) => (isCanadian ? toCanadianSpelling(text) : text), [isCanadian]);
}
